import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ICustomer } from 'app/models';
import { ICountry } from 'app/models/country.model';
import { CustomerService } from 'app/services';
import { CountryService } from 'app/services/country/country.service';
import { MessageService } from 'app/services/message/message.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from '../confirm-dialog/confirm-dialog.component';
import { CustomerMngtDetailComponent } from '../customer-mngt-detail/customer-mngt-detail.component';
import { AbstractSettingsFilteredTableComponent } from '../setting-mngt-filtered-table';
import {
  ViewImgDialogComponent,
  ViewImgDialogModel,
} from '../view-img-dialog/view-img-dialog.component';

@Component({
  selector: 'app-customer-mngt',
  templateUrl: './customer-mngt.component.html',
  styleUrls: ['./customer-mngt.component.scss'],
})
export class CustomerMngtComponent extends AbstractSettingsFilteredTableComponent<ICustomer> implements OnInit {

  @ViewChild(CustomerMngtDetailComponent)
  private customerMngtDetailComponent!: CustomerMngtDetailComponent;

  countries: ICountry[] = [];

  displayedColumns = [
    'name',
    'address',
    'city',
    'email',
    'hasImage',
    'country',
    'timeZone',
    'Actions',
  ];

  dataSource = new MatTableDataSource<ICustomer>();

  constructor(
    private customerService: CustomerService,
    private countryService: CountryService,
    public dialog: MatDialog,
    private messageService: MessageService
  ) {
    super();
  }

  ngOnInit() {
    this.getCustomers();
    this.loadCountries();
  }

  onCustomerSaved(saved: boolean) {
    const msg: string = saved
      ? ` Customer correctly saved `
      : ` Customer NOT correctly saved `;
    this.messageService.showDirectSimpleMessage(msg);
    this.getCustomers();
  }

  getCustomers(): void {
    this.customerService.findAllCustomers().subscribe(
      (customers) => (this.dataSource.data = customers as ICustomer[]),
      () =>
        this.messageService.showDirectSimpleMessage(` Loading customers error `)
    );
  }

  getCustomerById(id: number): ICustomer | undefined {
    return this.dataSource.data .find((item) => item.id === id);
  }

  getCountryById(id: string): ICountry | undefined {
    return this.countries .find((item) => item.id === id);
  }

  loadCountries(): void {
    this.countries = this.countryService.findAll();
  }

  deleteConfirmDialog(customerToBeDeleted: ICustomer): void {
    const message = `Are you sure you want to delete the customer with name ${customerToBeDeleted.name} and all its associated machines ?`;
    const dialogData = new ConfirmDialogModel('Confirm Delete Action', message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        if (customerToBeDeleted.id) {
          this.customerService.deleteCustomer(customerToBeDeleted.id).subscribe(
            () =>
              this.messageService.showDirectSimpleMessage(` Customer deleted `),
            () =>
              this.messageService.showDirectSimpleMessage(
                ` Customer delete error `
              ),
            () => this.getCustomers()
          );
        }
      }
    });
  }

  edit(customer: ICustomer): void {
    this.customerMngtDetailComponent.initEdit(customer);
  }

  viewImgDialog(customerId: number): void {
    this.customerService.findOneCustomer(customerId).subscribe(
      (res) => {
        if (res.imageStr) {
          const dialogData = new ViewImgDialogModel(res.imageStr);
          this.dialog.open(ViewImgDialogComponent, {
            data: dialogData,
          });
        }
      },
      () => this.messageService.showDirectSimpleMessage(` img load error `)
    );
  }

  doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  };

}
